document.addEventListener('alpine:init', () => {
  const UTILS = {
    FormatMoney(cents) {
      return theme.Currency.formatMoney(cents);
    },
    ObserveIntersection(node, config, callback) {
      if (!node) callback(null);
      let observer = new IntersectionObserver((entries) => {
        callback(entries);
      }, config);
      
      observer.observe(node, config);  
      return observer
    }  
  };

  Alpine.data('ProductStickyATC', () => ({
    cache: {},
    product: null,
    current_variant: null,
    init() {
      this.InitSelf();
      this.InitCache();
      this.InitWatchers();
    },
    InitSelf() {
      let am = this;
      am.product = JSON.parse(am.$el.dataset.product);
      am.current_variant = JSON.parse(am.$el.dataset.variant);
      document.addEventListener('variant:change', (e) => {
        am.current_variant = e.detail.variant;
      });
    },
    InitCache() {
      let am = this;
      am.cache.$block = am.$el.closest('.product-block');
      am.cache.$product_block = am.$el.closest('.product-single__meta');
      am.cache.$atc_form = am.cache.$block.querySelector('form');
    },
    InitWatchers() {
      let am = this;
      UTILS.ObserveIntersection(am.cache.$atc_form, {}, (entries) => {
        let entry = entries[0];
        let is_sticky = window.scrollY > (am.cache.$atc_form.offsetTop + am.cache.$atc_form.offsetHeight) && !entry.isIntersecting;
        am.$el.classList.toggle('active', is_sticky);
      });
    },
    FormatMoney(cents) {
      return UTILS.FormatMoney(cents);
    },
    GetVariantMedia() {
      let am = this;
      let media = am.current_variant.featured_media ? am.current_variant.featured_media : am.product.media[0];
      // console.log(am.current_variant, am.product, media);
      return media;
    },
    e_ScrollToFrom() {
      let am = this;
      window.scrollTo({
        top: am.cache.$product_block.offsetTop,
        behavior: 'smooth'
      })
    }
  }));

  Alpine.data('VideoMp4', () => ({
    flags: {
      paused: true
    },
    cache: {},
    init() {
      this.InitCache();
      this.InitSelf();
      this.InitWatchers();
      this.InitEventHandlers();
    },
    InitSelf() {
      let am = this;
      am.cache.$video.poster = am.cache.$video.poster.replace('_small', '');
      UTILS.ObserveIntersection(am.cache.$video, {}, (entries) => {
        let entry = entries[0];
        am.cache.$video[entry.isIntersecting ? 'play' : 'pause']();
      });
    },
    InitWatchers() {
      let am = this;
      am.$watch('flags.paused', () => {
        am.cache.$video.controls = !am.flags.paused;
        am.cache.$video.muted = !am.flags.paused;
        am.cache.$video[am.flags.paused ? 'pause' : 'play']();
      });
    },
    InitCache() {
      let am = this;
      am.cache.$video = am.$el.querySelector('video');
    },
    InitEventHandlers() {
      let am = this;
      am.cache.$video.addEventListener('pause', () => {
        am.flags.paused = true;
      });
      am.cache.$video.addEventListener('play', () => {
        am.flags.paused = false;
      });
    },
    e_ToggleVideoPlay() {
      let am = this;
      am.flags.paused = !am.flags.paused;
    }
  }));
});